import React, { useEffect } from 'react';
import { u as useOnKeyDown_2 } from './useOnKeyDown-t-UhpB2o.js';
import { u as useRefocusOnActivator_2 } from './useRefocusOnActivator-CiCzAHtv.js';
import { I as Icon } from './Icon-8KKXFsxm.js';

var styles = {"optionsList":"thBUfVNaigs-","option":"QaXuqbVjG04-"};

function DataListSortingOptions({ options, selectedOption, onSelectChange, onClose, optionsListRef, dataListHeaderTileRef, }) {
    useRefocusOnActivator_2(!optionsListRef.current);
    useOnKeyDown_2(() => onClose(), "Escape");
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionsListRef, dataListHeaderTileRef, onClose]);
    return (React.createElement("ul", { className: styles.optionsList, ref: optionsListRef }, options.map(option => (React.createElement("li", { className: styles.option, key: `${option.id}${option.order}`, onClick: () => onSelectChange(option), onKeyDown: event => handleKeyDown(event, option), tabIndex: 0, "data-value": option.id },
        option.label,
        option.label === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) && (React.createElement(Icon, { name: "checkmark", color: "blue" })))))));
    function handleKeyDown(event, option) {
        if (event.key === "Enter") {
            onSelectChange(option);
        }
    }
    function handleClickOutside(event) {
        var _a, _b;
        const isClickInside = ((_a = optionsListRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ||
            ((_b = dataListHeaderTileRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target));
        if (!isClickInside) {
            onClose();
        }
    }
}

export { DataListSortingOptions as D };
